import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=5507be86&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"
import style0 from "./collection.vue?vue&type=style&index=0&id=5507be86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507be86",
  null
  
)

export default component.exports